<template>
  <div>
    <div>
      <a
        title="点击下载"
        target="_blank"
        :href="
          file
            ? url
            : OssCofing.prefixUrl +
              OssCofing.folder +
              'certificate/' +
              factoryInfo.detail.new_number +
              '/' +
              detail.file
        "
        :download="detail.file"
        style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis"
      >
        点击下载
      </a>
      <el-button size="small" type="primary" @click="$refs.upload.click()"
        >重新上传
      </el-button>
      <input ref="upload" type="file" @change="upload" style="display: none" />
    </div>
  </div>
</template>
<script>
import { certificate } from "@/api/factory/function";
import { getOssSts } from "@/api/system/function";
import OssCofing from "@/plugins/oss.js";
import OSS from "ali-oss";
export default {
  inject: ["factoryInfo", "factoryCertifiaate"],
  data() {
    return {
      file: null,
      url: null,
      OssCofing,
    };
  },
  props: {
    detail: {
      default: {},
      value: Object,
    },
  },
  methods: {
    upload() {
      let files = this.$refs.upload.files[0];
      if (this.factoryCertifiaate.loading == false && files) {
        this.factoryCertifiaate.loading = true;
        this.file = files;
        this.$set(this.detail, "file", files.name);
        this.url = encodeURI(URL.createObjectURL(files));
        if (!this.file) {
          this.$message({
            showClose: true,
            message: "请先上传附件",
            type: "error",
          });
          this.factoryCertifiaate.loading = false;
          return;
        }
        getOssSts()
          .then((token) => {
            if (token) {
              let path =
                OssCofing.folder +
                "certificate/" +
                this.factoryInfo.detail.new_number +
                "/";
              let client = new OSS({
                region: OssCofing.region,
                accessKeyId: token.data.AccessKeyId,
                accessKeySecret: token.data.AccessKeySecret,
                stsToken: token.data.SecurityToken,
                bucket: OssCofing.bucket,
              });
              client
                .put(path + this.detail.file, this.file)
                .then(() => {
                  certificate()
                    .certificateEdit(this.detail)
                    .then((v) => {
                      this.$message({
                        showClose: true,
                        message: "修改成功",
                        type: "success",
                      });
                    })
                    .finally(() => {
                      this.factoryCertifiaate.loading = false;
                    });
                })
                .catch((err) => {
                  this.$message({
                    showClose: true,
                    message: "附件上传失败",
                    type: "error",
                  });
                  this.factoryCertifiaate.loading = false;
                });
            }
          })
          .catch((err) => {
            this.$message({
              showClose: true,
              message: "附件上传失败",
              type: "error",
            });
            this.factoryCertifiaate.loading = false;
          });
      }
    },
  },
};
</script>